import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Observable } from "rxjs";
import { UserNotify } from "src/app/support/notify-decorator";
import { PageRequest } from "src/app/support/page-request";
import { Injectable } from "@angular/core";
import { Import, ImportCreate } from "../models/import";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { PaginatedResult } from "src/app/support/paginated-result";
import { map } from "rxjs/operators";

@Injectable()
export class ImportBackend {
  constructor(private readonly http: HttpClient) {}

  @UserNotify({
    successMessage: marker("Importazione creata"),
    errorMessage: marker("Impossibile creare l'importazione")
  })
  create(request: ImportCreate): Observable<Import> {
    return this.http.post<Import>(
      `${environment.snoots.api.healthcare}/imports`,
      request
    );
  }

  load(id: string): Observable<Import> {
    return this.http
      .get<Import>(`${environment.snoots.api.healthcare}/imports/${id}`)
      .pipe(map(extendDoc));
  }

  list(request: PageRequest): Observable<PaginatedResult<Import>> {
    return this.http
      .get<PaginatedResult<Import>>(
        `${environment.snoots.api.healthcare}/imports`,
        {
          params: {
            p: request.page,
            s: request.pageSize
          }
        }
      )
      .pipe(
        map((result) => {
          return {
            ...result,
            docs: result.docs.map(extendDoc)
          };
        })
      );
  }

  // @UserNotify({
  //   successMessage: marker("Profilo fiscale aggiornato"),
  //   errorMessage: marker("Impossibile aggiornare il profilo fiscale")
  // })
  // update(id: string, request: Partial<ImportUpdate>): Observable<void> {
  //   return this.http.patch<void>(
  //     `${environment.snoots.api.healthcare}/imports/${id}`,
  //     request
  //   );
  // }

  @UserNotify({
    successMessage: marker("Importazione rimossa"),
    errorMessage: marker("Impossibile rimuovere l'importazione")
  })
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.healthcare}/imports/${id}`
    );
  }
}

function extendDoc(imports: Import): Import {
  return {
    ...imports,
    status: imports.status === "created" ? "in-progress" : imports.status
  };
}
